import { useMutation } from "@apollo/client/react";
import { mutations } from "@/graphql";
import { useCallback } from "react";

const SEND_WELCOME_EMAIL = mutations.sendWelcomeEmail;

// export function useSendWelcomeEmail(
//   onCompleted = () => {},
//   onError = () => {}
// ) {
//   const [comSendWelcomeEmail, { loading }] = useMutation<any>(SEND_WELCOME_EMAIL, {
//     onCompleted: () => {
//       onCompleted();
//     },
//     onError: () => {
//       onError();
//     }
//   });
//   const sendEmail = useCallback(
//     ({ email }) => {
//       comSendWelcomeEmail({
//         variables: {
//           email
//         }
//       });
//     },
//     [comSendWelcomeEmail]
//   );

/**
 *
 * @param onCompleted
 * @param onError
 */
export function useSendWelcomeEmail(
  onCompleted = () => {},
  onError = () => {},
) {
  const [comSendWelcomeEmail, { loading }] = useMutation<any>(
    SEND_WELCOME_EMAIL,
    {
      onCompleted: () => {
        onCompleted();
      },
      onError: () => {
        onError();
      },
    },
  );

  const sendEmail = useCallback(
    (email: string) => {
      comSendWelcomeEmail({
        variables: {
          email,
        },
      });
    },
    [comSendWelcomeEmail],
  );

  return {
    sendEmail,
    loading,
  };
}
